export function getPublicCategoryDisplayLimit(tier) {
  const normalized = String(tier || '').trim().toLowerCase();
  if (normalized === 'spotlight') return 4;
  if (normalized === 'featured') return 2;
  return 1;
}
